import styled from "styled-components";

export const StyleModal = styled.div`
  .modal-panel {
    display: inline-block;
    position: relative;
    width: 100%;
    min-width: 0;
    max-width: ${(props) => props.$maxWidth || "384px"};
    max-height: 88vh;
    vertical-align: middle;
    border-radius: 10px;
    background: rgb(26, 29, 41);
    box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 20px,
      rgba(255, 255, 255, 0.04) 0px 1px 0px inset,
      rgba(0, 0, 0, 0.25) 0px -4px 0px inset;
    color: #b1b6c6;
  }

  .overflow-modal {
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-corner,
    ::-webkit-scrollbar-track {
      background: 0 0;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(203, 215, 255, 0.1);
      border-radius: 6px;
    }
  }

  .modal-panel.auth-dialog-panel {
    overflow: hidden;
  }

  .modal-panel.auth-dialog-panel.overflow-modal {
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.72) rgba(8, 12, 20, 0.28);

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(8, 12, 20, 0.28);
      border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, rgba(112, 255, 139, 0.88), rgba(40, 217, 97, 0.68));
      border-radius: 999px;
    }
  }

  .modal-panel.wallet-dialog-panel {
    min-width: 0;
    overflow: hidden;
    border-radius: 20px;
    background: #142430;
    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.42),
      inset 0 1px 0 rgba(255, 255, 255, 0.04);
  }

  .modal-panel.wallet-dialog-panel.overflow-modal {
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.72) rgba(8, 12, 20, 0.28);

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(8, 12, 20, 0.28);
      border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, rgba(112, 255, 139, 0.88), rgba(40, 217, 97, 0.68));
      border-radius: 999px;
    }
  }

  .modal-panel.member-notice-dialog-panel {
    width: min(420px, calc(100vw - 36px));
    max-width: min(420px, calc(100vw - 36px));
    border: 1px solid rgba(89, 244, 119, 0.2);
    border-radius: 14px;
    padding: 0;
    color: #f6fbff;
    background: #0f232d;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.42),
      inset 0 1px 0 rgba(255, 255, 255, 0.04);
  }

  .modal-panel.member-notice-dialog-panel.overflow-modal {
    overflow: visible;
  }

  .member-notice-content {
    position: relative;
    padding: 24px;
  }

  .member-notice-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 8px;
    color: #aebccb;
    background: rgba(255, 255, 255, 0.05);
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.14s ease, background 0.14s ease;
  }

  .member-notice-close:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.08);
  }

  .member-notice-label {
    display: inline-flex;
    margin-bottom: 10px;
    color: var(--crypto-green);
    font-size: 12px;
    font-weight: 800;
  }

  .member-notice-content strong {
    display: block;
    padding-right: 32px;
    color: #ffffff;
    font-size: 20px;
    line-height: 1.25;
    font-weight: 800;
  }

  .member-notice-content p {
    margin: 10px 0 0;
    color: #a9b8c7;
    font-size: 14px;
    line-height: 1.55;
    font-weight: 500;
  }

  .member-notice-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 22px;
  }

  .member-notice-actions button {
    height: 38px;
    border: 0;
    border-radius: 8px;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    transition: filter 0.14s ease, background 0.14s ease, color 0.14s ease;
  }

  .notice-secondary {
    color: #c7d2df;
    background: rgba(255, 255, 255, 0.06);
  }

  .notice-secondary:hover {
    background: rgba(255, 255, 255, 0.09);
  }

  .notice-primary {
    color: #0d1713;
    background: var(--crypto-green);
  }

  .notice-primary:hover {
    filter: brightness(1.05);
  }

  .modal-panel.sports-bet-success-dialog-panel {
    width: min(380px, calc(100vw - 32px));
    border-color: rgba(89, 244, 119, 0.3);
    background:
      radial-gradient(circle at 50% 0%, rgba(89, 244, 119, 0.14), transparent 44%),
      #0f232d;
    box-shadow: 0 28px 76px rgba(0, 0, 0, 0.5),
      0 0 0 1px rgba(89, 244, 119, 0.05) inset;
  }

  .sports-bet-success-content {
    display: grid;
    justify-items: center;
    padding: 26px 24px 22px;
    text-align: center;
  }

  .sports-bet-success-icon {
    display: grid;
    place-items: center;
    width: 54px;
    height: 54px;
    margin-bottom: 14px;
    border-radius: 999px;
    color: #06110b;
    background: linear-gradient(180deg, #70ff8b, #28d961);
    box-shadow: 0 12px 30px rgba(40, 217, 97, 0.28);
  }

  .sports-bet-success-icon svg {
    width: 28px;
    height: 28px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2.8;
  }

  .sports-bet-success-content .member-notice-label {
    margin-bottom: 7px;
    letter-spacing: 0.08em;
  }

  .sports-bet-success-content strong {
    padding: 0;
    font-size: 21px;
  }

  .sports-bet-success-content p {
    max-width: 292px;
    margin-top: 9px;
    word-break: keep-all;
  }

  .sports-bet-success-actions {
    width: 100%;
    margin-top: 20px;
  }

  .sports-bet-success-actions .notice-primary {
    width: 100%;
    height: 42px;
  }

  @media (min-width: 1024px) {
    .modal-panel {
      max-height: 100%;
    }
  }
`;

export const StyledCloseButton = styled.div`
  position: sticky;
  z-index: 2;
  transform: translate(-20px, 26px);
  top: 0px;
  height: 0px;
  display: flex;
  justify-content: flex-end;

  .button-close {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border-radius: 99px;
    cursor: pointer;
    background: rgb(26, 29, 41);

    svg {
      vertical-align: middle;
      overflow: hidden;
      fill: currentcolor;
      width: 20px;
      min-width: 20px;
      height: auto;
      transition: color 0.1s ease 0s;
      color: rgb(177, 182, 198);

      &:hover {
        color: rgb(255, 255, 255);
      }
    }
  }
`;
